import {useReferencedCollectionItems} from '../useCollectionItems';
import type {ReferencedCollectionItems} from '@packages/systems/cms/types';
import {
  selectCurrentLocale,
  useLocalizationSelector,
} from '@packages/systems/localization';

type Props = {
  itemIdsByCollectionId: ReferencedCollectionItems;
  children: JSX.Element | ((areItemsLoading: boolean) => JSX.Element | null);
};

const CollectionItemsLoader = (props: Props) => {
  const {itemIdsByCollectionId} = props;
  const currentLocale = useLocalizationSelector(selectCurrentLocale);

  const multipleQueriesResult = useReferencedCollectionItems(
    itemIdsByCollectionId,
    {
      format: 'itemRef',
      locales: currentLocale ? [currentLocale] : undefined,
    }
  );

  if (typeof props.children === 'function') {
    const areItemsLoading = multipleQueriesResult.some(
      (queryResult) => queryResult.status === 'loading'
    );

    return props.children(areItemsLoading);
  }

  return props.children || null;
};

export default CollectionItemsLoader;
